import { SVGProps } from 'react';

export const ClipboardIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='13'
    height='12'
    viewBox='0 0 13 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <path
      d='M8.08287 1.94394C7.94957 1.47136 7.51523 1.125 7 1.125H5.5C4.98477 1.125 4.55043 1.47136 4.41713 1.94394M8.08287 1.94394C8.11032 2.04125 8.125 2.14391 8.125 2.25V2.25C8.125 2.45711 7.95711 2.625 7.75 2.625H4.75C4.54289 2.625 4.375 2.45711 4.375 2.25V2.25C4.375 2.14391 4.38968 2.04125 4.41713 1.94394M8.08287 1.94394C8.40596 1.96834 8.72727 1.99914 9.04666 2.0362C9.59696 2.10007 10 2.5745 10 3.12849V9.75C10 10.3713 9.49632 10.875 8.875 10.875H3.625C3.00368 10.875 2.5 10.3713 2.5 9.75V3.12849C2.5 2.5745 2.90304 2.10007 3.45334 2.0362C3.77273 1.99914 4.09404 1.96834 4.41713 1.94394'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
